import { Component, OnDestroy, OnInit } from '@angular/core';
import { FlowwerInitializaterComponent } from '../../../../shared/components/flowwwer-initializater-component/flowwwer-initializater-component';
import { ActivatedRoute, Router } from '@angular/router';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { NavController } from '@ionic/angular';
import { UserService } from '../../../../shared/state/user/user.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { TreatmentService } from '../../../../shared/state/treatment/treatment.service';
import { AppointmentService } from '../../../../shared/state/appointment/appointment.service';
import { MessageService } from '../../../../shared/state/message/message.service';
import { LibraryService } from '../../../../core/services/library/library.service';
import { MessageQuery } from 'src/app/shared/state/message/message.query';
import { Observable } from 'rxjs';
import { Message } from 'src/app/shared/state/message/message.model';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import { RouterService } from '../../../../core/services/router/router.service';
import {  fade_out } from 'src/app/core/animations/fade';

@Component({
    selector: 'app-user-tabs',
    animations: [fade_out],
    templateUrl: './user-tabs.component.html',
    styleUrls: ['./user-tabs.component.scss'],
})
export class UserTabsComponent
    extends FlowwerInitializaterComponent
    implements OnInit, OnDestroy {
    messages$: Observable<Message[]>;
    showClinicDetails$: Observable<boolean>;
    currentTab;
    isGeneric$: Observable<boolean>;
    isBrowser$: Observable<boolean>;
    isUserAccountATab: boolean;
    isFriendProgramATab: boolean;
    isEnabledUserAccount: boolean;

    constructor(
        private treatmentService: TreatmentService,
        private appointmentService: AppointmentService,
        private messageService: MessageService,
        private messageQuery: MessageQuery,
        private companyQuery: CompanyQuery,
        private router: Router,
        libraryService: LibraryService,
        clinicDetailQuery: ClinicDetailQuery,
        companyService: CompanyService,
        activatedRoute: ActivatedRoute,
        settingsService: SettingsService,
        clinicDetailService: ClinicDetailService,
        navCtrl: NavController,
        userService: UserService,
        settingsQuery: SettingsQuery,
        userQuery: UserQuery,
        routerService: RouterService
    ) {
        super(
            activatedRoute,
            settingsService,
            userService,
            companyService,
            clinicDetailService,
            navCtrl,
            clinicDetailQuery,
            settingsQuery,
            userQuery,
            libraryService,
            routerService
        );
    }

    async ngOnInit(): Promise<void> {
        this.isBrowser$ = this.settingsQuery.select('browser');
        this.currentTab = this.router.url.split('/')[3]?.split('?')[0];
        this.isGeneric$ = this.settingsQuery.selectIsGeneric();
        this.isLoadingContent = true;
        this.showClinicDetails$ = this.settingsQuery.select(
            'showClinicDetails'
        );

        this.settingsQuery.selectIsUserAccountATab().subscribe((value) => {
            this.isUserAccountATab = value;
        });
        this.settingsQuery.selectIsFriendProgramATab().subscribe((value) => {
            this.isFriendProgramATab = value;
        });
        this.settingsQuery.selectIsEnabledUserAccount().subscribe((value) => {
            this.isEnabledUserAccount = value;
        });

        try {
            await this.initializeCompanyClinicUser();
        } catch (error) {
            this.isLoadingContent = false;
            return;
        }

        /** Si hemos llegado aquí por ruta al /user-account y no aparece el tab
         * Tenemos que redirigir porque solo se podrá entrar a /user-account por modal */
        this.checkRedirectOnUserAccountModal();
        this.checkRedirectOnFriendProgramDisabled();

        /** TODO: CHAPUZA, metemos este timeout para quitar el skeleton de las tabs al cambiar de tab */
        setTimeout(() => {
            this.isLoadingContent = false;
        }, 200);

        this.messages$ = this.messageQuery.selectAll({
            filterBy: ({ read }) => read === false,
        });
    }

    /** Al destruir esta página, si volvemos hacia atrás, reseteamos la Store de los detalles de la clínica */
    ngOnDestroy(): void {
        this.unsuscribeParamsQueryParams();
        this.clinicDetailService.resetStore();
        this.userService.resetStore();
        this.treatmentService.setTreatments([]);
        this.appointmentService.setAppointments([]);

        if (
            this.settingsQuery.isGeneric() ||
            this.companyQuery.systemReseller === '-1'
        ) {
            this.messageService.setMessages([]);
        }
    }

    checkRedirectOnUserAccountModal() {
        /**
         * Programa amigo, no puedo entrar a estas páginas si van a funcionar como modals
         */
        if (
            this.currentTab === 'user-account' &&
            (!this.isUserAccountATab || !this.isEnabledUserAccount)
        ) {
            this.router.navigate([
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/details',
            ]);
        }
    }

    checkRedirectOnFriendProgramDisabled() {
        /**
         * Programa amigo, no puedo entrar a programa amigo si no está activado para la company o es Flowwwer
         */
        if (this.currentTab === 'friend-program' && !this.isFriendProgramATab) {
            this.router.navigate([
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/details',
            ]);
        }
    }
}
